import {
  useAPIKinerja,
  useAPIPelaksanaanProgress,
} from 'api/kinerja/useAPIKinerja'

export default function usePelaksanaan(enabled: boolean) {
  const {
    data,
    isFetched: isPerencanaanFetched,
    refetch: refetchSKP,
  } = useAPIKinerja({
    enabled,
  })
  const {
    data: dataPelaksanaan,
    isLoading: isLoadingPelaksanaan,
    isError,
  } = useAPIPelaksanaanProgress({
    opts: {
      useErrorBoundary: false,
      enabled: isPerencanaanFetched && data?.data?.status === 'READY',
      retry: 5,
      retryDelay: 750,
    },
  })

  return {
    refetchSKP,
    dataPerencanaan: data,
    dataPelaksanaan,
    isErrorPelaksanaan: isError,
    isLoadingPelaksanaan,
    isPerencanaanFetched,
  }
}
